import { Component, Input } from '@angular/core';
import { AlternativeQuestionChartResult } from '@core/interfaces';

@Component({
  selector: 'app-alternative-question-chart',
  templateUrl: './alternative-question-chart.component.html',
  styleUrls: ['./alternative-question-chart.component.scss']
})
export class AlternativeQuestionChartComponent{
  @Input() title: string;
  @Input() isLoading = true;
  @Input() results: AlternativeQuestionChartResult;
}
